import React, { Component } from "react";
import axios from "axios";
import { Col, Input, message, Row, Space, Form as FormInitial, Select } from "antd";
import { BoxItem, ButtonItem, Form, FormItem, HeaderItem, InputItem, InputNumberItem, SelectItem, SwitchItem, ModalItem, ErrorItem } from "../../../../Components/Items";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import AgregarUnidad from "../../Insumos/AgregarInsumo/AgregarUnidad/AgregarUnidad";
import AgregarFamilia from "../../Familias/AgregarFamilia/AgregarFamilia";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";

const { Option } = Select;

class ModalAgregarInsumoRequisicion extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        todasRetenciones: [],
        todasImpuestos: [],
        todasFamilia: [],
        todasUnidades: [],
        todasTipoDeInsumo: [],
        todasMarcas: [],
        calcularPreciosAutomaticamente: false,
        calcularPreciosSobre: "",
        precios: [],
        objetoUnidades: [],
        objetoFamilia: [],
        objetoImpuestos: [],
        objetoRetenciones: [],
        objetoMarcas: [],
        buscarInfoCodigo: "",
        codBarObligatorio: false,
        familiaGastoNoDeducible: false,
        valuacionInventarios: undefined,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarDatos();
        }
    }

    consultarDatos = () => {
        this.setState({ loading: true });
        axios
            .post(
                "insumos/selectDatosParaInsumo",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) {
                    message.error("Error al obtener los datos");
                    this.setState({ loading: false });
                    return;
                }
                this.setState({
                    loading: false,
                    todasRetenciones: res.data.retenciones,
                    todasImpuestos: res.data.impuestos,
                    todasFamilia: res.data.familias,
                    todasUnidades: res.data.unidades,
                    todasTipoDeInsumo: res.data.tiposInsumos,
                    todasMarcas: res.data.marcas,
                    calcularPreciosAutomaticamente: res.data.configuracion.calcularPreciosAutomaticamente,
                    calcularPreciosSobre: res.data.configuracion.calcularPreciosSobre,
                    codBarObligatorio: res.data.configuracion.codBarObligatorio,
                    valuacionInventarios: res.data.configuracion?.valuacionInventarios,
                    precios: res.data.configuracion.precios.map((value) => ({
                        porcentaje: value.porcentaje,
                        nombre: value.nombre,
                        precioId: value._id,
                    })),
                    objetoUnidades: res.data.unidades.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value.unidadSat.c_ClaveUnidad + " - " + value.nombre}
                        </Option>
                    )),
                    objetoFamilia: res.data.familias.map((value) => (
                        <Option value={value._id} key={value._id}>{value.nombre}</Option>
                    )),
                    objetoImpuestos: res.data.impuestos.map((value) => (
                        <Option value={value._id} key={value._id}>{value.nombre}</Option>
                    )),
                    objetoRetenciones: res.data.retenciones.map((value) => (
                        <Option value={value._id} key={value._id}>{value.nombre}</Option>
                    )),
                    objetoMarcas: res.data.marcas.map((value) => (
                        <Option value={value._id} key={value._id}>{value.nombre}</Option>
                    )),
                }, () => {
                    const impuestosPredeterminados = Array.isArray(res.data?.configuracion?.impuestosPredeterminados)
                        ? res.data.configuracion.impuestosPredeterminados
                        : [];
                    let cargarIP = true;
                    impuestosPredeterminados.forEach((valueIP) => {
                        if (!valueIP?.impuestoId) { cargarIP = false; return; }
                        if (!this.state.todasImpuestos.find((v) => v._id.toString() === valueIP.impuestoId?.toString())) {
                            cargarIP = false;
                        }
                    });
                    const retencionesPredeterminadas = Array.isArray(res.data?.configuracion?.retencionesPredeterminadas) ? res.data.configuracion.retencionesPredeterminadas : []

                    let cargarRP = true
                    retencionesPredeterminadas.forEach((valueRP) => {
                        if (!valueRP?.retencionId) {
                        cargarRP = false
                        }
                        if (!this.state.todasRetenciones.find((valueTodasRetencion) => valueTodasRetencion._id.toString() === valueRP.retencionId?.toString())) {
                        cargarRP = false
                        }
                    })
                    this.formRef.current?.setFieldsValue({
                        codigo: res.data.sigNumero,
                        clave: res.data.sigNumero,
                        venta: false,
                        compra: true,
                        impuestos: cargarIP ? impuestosPredeterminados : [],
                        retenciones: cargarRP ? retencionesPredeterminadas : [],
                        ...(res.data.siHayConfiguracionAutomatizada ? {
                        venta:              res.data?.configuracion?.venta || false ,
                        compra:             res.data?.configuracion?.compra || false ,
                        verInsumoVenta:     res.data?.configuracion?.verInsumoVenta || false ,
                        leyendaVenta:       res.data?.configuracion?.leyendaVenta || false ,
                        observaciones:      res.data?.configuracion?.observaciones || false ,
                        observacionesVenta: res.data?.configuracion?.observacionesVenta || false ,
                        inventariable:      res.data?.configuracion?.inventariable || false ,
                        lotesCaducidades:   res.data?.configuracion?.lotesCaducidades || false ,
                        }: {}),
                        precios: res.data.configuracion.precios.map((value) => ({
                            porcentaje: value.porcentaje,
                            nombre: value.nombre,
                            precioId: value._id,
                        })),
                    });
                });
            });
    };

    onChangeCodigo(value) {
        this.setState({ buscarInfoCode: true });
        axios
            .post(
                "codigoinsumos/buscarCodigoLista",
                { empresaId: this.props.empresaId, codigo: value },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status !== 404) {
                    this.setState({
                        todasCodigoSat: res.data,
                        buscarInfoCode: false,
                        objetoCodigoSat: res.data.map((value) => (
                            <Option value={value._id} key={value._id}>
                                {value.c_ClaveProdServ + " - " + value.descripcion}
                            </Option>
                        )),
                    });
                }
            });
    }

    cerrar = (insumoId, nuevoInsumo) => {
        this.props.cerrar(insumoId, nuevoInsumo);
        this.formRef.current?.resetFields();
    };

    abrirAgregarUnidad() { this.setState({ modalAgregarUnidad: true }); }
    cerrarAgregarUnidad() { this.setState({ modalAgregarUnidad: false }); }

    abrirAgregarCuentaContable() { this.setState({ modalAgregarCuentaContable: true }); }
    cerrarAgregarCuentaContable() { this.setState({ modalAgregarCuentaContable: false }); this.consultarDatos(); }

    abrirAgregarFamilia() { this.setState({ modalAgregarFamilia: true }); }
    cerrarAgregarFamilia() { this.setState({ modalAgregarFamilia: false }); this.consultarDatos(); }

    onChangeImpuesto() {
        const impuestos = this.formRef.current.getFieldValue('impuestos');
        let combustible = false;
        let impuestoIdCombustible;
        impuestos.forEach((valueImpuesto) => {
            if (valueImpuesto?.impuestoId) {
                const impuesto = this.state.todasImpuestos.find(
                    (v) => v._id.toString() === valueImpuesto.impuestoId.toString()
                );
                if (impuesto?.combustible) { combustible = true; impuestoIdCombustible = impuesto._id; }
            }
        });
        if (combustible) {
            message.info('Si el impuesto es especial solamente se puede elegir uno y no se puede vender');
            this.setState({ impuestoCombustible: true });
            this.formRef.current.setFieldsValue({ impuestos: [{ impuestoId: impuestoIdCombustible }], venta: false });
        } else {
            this.setState({ impuestoCombustible: false });
        }
    }

    onChangeCosto() {
        if (!this.formRef.current) return;
        const valueCosto = this.formRef.current.getFieldValue("costo");
        if (!valueCosto) return;
        const arrayValues = this.formRef.current.getFieldValue("precios");
        const arrayNuevo = arrayValues.map((value) => {
            const precio = this.state.calcularPreciosSobre
                ? ((valueCosto * (100 + value.porcentaje)) / 100).toFixed(2)
                : (valueCosto / ((100 - value.porcentaje) / 100)).toFixed(2);
            return { ...value, precio };
        });
        this.formRef.current.setFieldsValue({ precios: arrayNuevo });
    }

    onChangeFamlia(familiaId) {
        const familia = this.state.todasFamilia.find(
            (v) => v._id.toString() === familiaId.toString()
        );
        if (familia?.gastoNoDeducible) {
            message.info('Si la familia es gasto no deducible no se puede inventariar ni vender');
            this.setState({ familiaGastoNoDeducible: true });
            this.formRef.current.setFieldsValue({ inventariable: false, venta: false });
        } else {
            this.setState({ familiaGastoNoDeducible: false });
        }
    }

    onFinish(values) {
        this.setState({ loading: true });
        const fd = new FormData();
        fd.append("empresaId", this.props.empresaId);
        fd.append("verInsumoCompleto", true);
        if (this.state.valuacionInventarios !== undefined) {
            fd.append("valuacionInventarios", this.state.valuacionInventarios);
        }
        for (const key in values) {
            if (values[key] === undefined || values[key] === "") continue;
            const arrKeys = ["precios", "equivalencias", "conversiones", "impuestos", "relacionesAutomaticas", "retenciones"];
            if (arrKeys.includes(key)) {
                fd.append(key, JSON.stringify(values[key]));
            } else if (values[key] !== null) {
                fd.append(key, values[key]);
            }
        }
        axios
            .post("insumos/agregarInsumo", fd, { headers: { ...this.props.headersToken } })
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado el insumo");
                    this.cerrar(res.data.codigo, res.data.nuevoInsumo);
                } else if (res.data.success === 1) {
                    message.error(res.data.message || "No se puede registrar el insumo");
                } else {
                    message.error("Hubo un error y el insumo no se registró");
                }
            });
    }

    onFinishFailed(e) { ErrorItem(e); }

    render() {
        return (
            <ModalItem
                title="Crear Insumo"
                visible={this.props.visible}
                onCancel={() => this.cerrar()}
                spinning={this.state.loading}
                width={900}
            >
                <Form
                    ref={this.formRef}
                    name="agregarInsumoRequisicion"
                    layout
                    bottom={
                        <div style={{ display: "flex", justifyContent: "right" }}>
                            <Space>
                                <ButtonItem type="primary" size="small" danger onClick={() => this.cerrar()}>
                                    Cancelar
                                </ButtonItem>
                                <ButtonItem type="primary" size="small" htmlType="submit">
                                    Guardar
                                </ButtonItem>
                            </Space>
                        </div>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Row gutter={16}>
                        <Col xs={24} lg={12}>
                            <FormItem label="Permitir Venta" name="venta" margin initialValue={false} valuePropName="checked">
                                <SwitchItem />
                            </FormItem>
                            <FormItem label="Permitir Compra" name="compra" margin initialValue={true} valuePropName="checked">
                                <SwitchItem />
                            </FormItem>
                            <FormItem name="leyendaVenta" label="Leyenda" margin valuePropName="checked"
                                tooltip={{ title: "Activara cambiar leyenda en ventas" }}>
                                <SwitchItem />
                            </FormItem>
                            <FormItem name="observacionesVenta" label="Observaciones" margin valuePropName="checked"
                                tooltip={{ title: "Activara cambiar observaciones en ventas" }}>
                                <SwitchItem />
                            </FormItem>
                            <FormItem name="codigo" label="Codigo" margin pattern initialValue={this.state.sigNumero}>
                                <InputItem disabled placeholder="Codigo" />
                            </FormItem>
                            <FormItem label="Cod. barras" name="codigoBarras" margin pattern required={this.state.codBarObligatorio}>
                                <InputItem placeholder="Codigo de barras" />
                            </FormItem>
                            <FormItem name="clave" label="Clave" margin pattern>
                                <InputItem placeholder="Clave" />
                            </FormItem>
                            <FormItem label="Descripción" name="descripcion" required margin pattern>
                                <InputItem placeholder="Descripción" />
                            </FormItem>
                            <FormItem label="Descripción Larga" name="descripcionLarga" required margin pattern>
                                <InputItem placeholder="Descripción larga" />
                            </FormItem>
                            <FormItem label="Marca" name="marcaId" margin>
                                <SelectItem allowClear placeholder="Marca">
                                    {this.state.objetoMarcas}
                                </SelectItem>
                            </FormItem>
                            <FormItem label="Unidad" margin>
                                <Input.Group compact>
                                    <FormItem name="unidadId" required noStyle>
                                        <SelectItem placeholder="Unidad" width="80%">
                                            {this.state.objetoUnidades}
                                        </SelectItem>
                                    </FormItem>
                                    <ButtonItem blanco icon={<PlusOutlined />} style={{ width: "20%" }} onClick={this.abrirAgregarUnidad.bind(this)} />
                                </Input.Group>
                            </FormItem>
                            <HeaderItem>Impuestos y Retenciones</HeaderItem>
                            <BoxItem>
                                <Row>
                                    <Col xs={24} sm={12}>
                                        <p style={{ textAlign: 'center' }}>Impuestos</p>
                                        <FormInitial.List name="impuestos">
                                            {(fields, { add, remove }) => (
                                                <>
                                                    {fields.map(({ name }, arrayKey) => (
                                                        <Row key={arrayKey.toString()} gutter={6} style={{ marginBottom: 6 }} align="middle">
                                                            <Col flex="1">
                                                                <FormItem name={[name, "impuestoId"]} fieldKey={[arrayKey, "impuestoId"]} required noStyle>
                                                                    <SelectItem width='100%' placeholder="Impuesto" size="small" onChange={this.onChangeImpuesto.bind(this)}>
                                                                        {this.state.objetoImpuestos}
                                                                    </SelectItem>
                                                                </FormItem>
                                                            </Col>
                                                            <Col flex="28px">
                                                                <DeleteOutlined
                                                                    style={{ color: '#ff4d4f', cursor: 'pointer', fontSize: '16px' }}
                                                                    onClick={() => { remove(name); this.onChangeImpuesto(); }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                    {!this.state.impuestoCombustible && (
                                                        <ButtonItem type="dashed" onClick={() => add()} icon={<PlusOutlined />} size="small" block>
                                                            Agregar
                                                        </ButtonItem>
                                                    )}
                                                </>
                                            )}
                                        </FormInitial.List>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <p style={{ textAlign: 'center' }}>Retenciones</p>
                                        <FormInitial.List name="retenciones">
                                            {(fields, { add, remove }) => (
                                                <>
                                                    {fields.map(({ name }, arrayKey) => (
                                                        <Row key={arrayKey.toString()} gutter={6} style={{ marginBottom: 6 }} align="middle">
                                                            <Col flex="1">
                                                                <FormItem name={[name, "retencionId"]} fieldKey={[arrayKey, "retencionId"]} required noStyle>
                                                                    <SelectItem width='100%' placeholder="Retención" size="small">
                                                                        {this.state.objetoRetenciones}
                                                                    </SelectItem>
                                                                </FormItem>
                                                            </Col>
                                                            <Col flex="28px">
                                                                <DeleteOutlined
                                                                    style={{ color: '#ff4d4f', cursor: 'pointer', fontSize: '16px' }}
                                                                    onClick={() => remove(name)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                    <ButtonItem type="dashed" onClick={() => add()} icon={<PlusOutlined />} size="small" block>
                                                        Agregar
                                                    </ButtonItem>
                                                </>
                                            )}
                                        </FormInitial.List>
                                    </Col>
                                </Row>
                            </BoxItem>
                        </Col>
                        <Col xs={24} lg={12}>
                            <FormItem label="Costo" name="costo" required margin numberCero>
                                <InputNumberItem placeholder="Costo" dinero onChange={this.onChangeCosto.bind(this)} />
                            </FormItem>
                            <FormItem label="Familia" margin>
                                <Input.Group compact>
                                    <FormItem name="familiaId" required noStyle>
                                        <SelectItem onChange={this.onChangeFamlia.bind(this)} placeholder="Familia" width="80%">
                                            {this.state.objetoFamilia}
                                        </SelectItem>
                                    </FormItem>
                                    <ButtonItem icon={<PlusOutlined />} style={{ width: "20%" }} onClick={this.abrirAgregarFamilia.bind(this)} />
                                </Input.Group>
                            </FormItem>
                            <FormItem name="inventariable" label="Inventariable" margin valuePropName="checked" initialValue={false}>
                                <SwitchItem disabled={this.state.familiaGastoNoDeducible} />
                            </FormItem>
                            {this.props.lotesCaducidades && (
                                <FormItem name="lotesCaducidades" label="Lotes y Caducidades" margin valuePropName="checked" specialLayoutSwitch
                                    tooltip={{ title: "Llevar control de lotes y caducidades" }}>
                                    <SwitchItem />
                                </FormItem>
                            )}
                            <FormItem noStyle shouldUpdate={(prev, curr) => prev.venta !== curr.venta}>
                                {({ getFieldValue }) => {
                                    if (!getFieldValue('venta')) return null;
                                    return (
                                        <FormInitial.List name="precios"
                                            initialValue={this.state.precios.map((v) => ({
                                                porcentaje: v.porcentaje,
                                                nombre: v.nombre,
                                                precioId: v.precioId,
                                            }))}
                                        >
                                            {(fields) => (
                                                <>
                                                    {fields.map(({ key, name }, otro) => (
                                                        <FormItem key={key} label={"Precio " + this.state.precios[key]?.nombre} margin shouldUpdate>
                                                            <Input.Group compact>
                                                                <FormItem name={[name, "porcentaje"]} required numberCero noStyle>
                                                                    <InputNumberItem sinWidth porcentaje
                                                                        onChange={(value) => {
                                                                            const arr = this.formRef.current.getFieldValue("precios");
                                                                            const costo = this.formRef.current.getFieldValue("costo");
                                                                            if (!costo) return;
                                                                            arr[key].precio = this.state.calcularPreciosSobre
                                                                                ? ((costo * (100 + value)) / 100).toFixed(2)
                                                                                : (costo / ((100 - value) / 100)).toFixed(2);
                                                                            this.formRef.current.setFieldsValue({ precios: arr });
                                                                        }}
                                                                    />
                                                                </FormItem>
                                                                <FormItem name={[name, "precio"]} required numberCero noStyle>
                                                                    <InputNumberItem sinWidth dinero placeholder={"Precio " + this.state.precios[key]?.nombre}
                                                                        onChange={(value) => {
                                                                            const arr = this.formRef.current.getFieldValue("precios");
                                                                            const costo = this.formRef.current.getFieldValue("costo");
                                                                            if (!costo) return;
                                                                            arr[key].porcentaje = this.state.calcularPreciosSobre
                                                                                ? (((value - costo) / costo) * 100).toFixed(2)
                                                                                : (((value - costo) / value) * 100).toFixed(2);
                                                                            this.formRef.current.setFieldsValue({ precios: arr });
                                                                        }}
                                                                    />
                                                                </FormItem>
                                                            </Input.Group>
                                                        </FormItem>
                                                    ))}
                                                </>
                                            )}
                                        </FormInitial.List>
                                    );
                                }}
                            </FormItem>
                            <FormItem noStyle shouldUpdate={(prev, curr) => prev.venta !== curr.venta}>
                                {({ getFieldValue }) => getFieldValue('venta') ? (
                                    <>
                                        <HeaderItem>CODIGOS SAT</HeaderItem>
                                        <BoxItem>
                                            <Row>
                                                <Col span={24}>
                                                    <FormItem label="Codigo Sat" name="codigoSatId" required margin>
                                                        <SelectItem mostrarCarga loading={this.state.buscarInfoCodigo}
                                                            placeholder="Codigo Sat"
                                                            onSearch={(value) => this.onChangeCodigo(value)}>
                                                            <Option disabled>Escriba para buscar el codigo</Option>
                                                            {this.state.objetoCodigoSat}
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                            <Row style={{ textAlign: 'center', justifyContent: 'center' }}>
                                                <ButtonItem style={{ width: "50%", marginTop: "10px" }}
                                                    onClick={() => window.open("http://pys.sat.gob.mx/PyS/catPyS.aspx", "_blank")}>
                                                    Conoce tu codigo sat
                                                </ButtonItem>
                                            </Row>
                                        </BoxItem>
                                    </>
                                ) : null}
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
                <AgregarUnidad visible={this.state.modalAgregarUnidad} cerrarAgregarUnidad={this.cerrarAgregarUnidad.bind(this)} />
                <AgregarFamilia visible={this.state.modalAgregarFamilia} cerrarAgregarFamilia={this.cerrarAgregarFamilia.bind(this)} />
                <AgregarCuentaContable visible={this.state.modalAgregarCuentaContable} cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)} />
            </ModalItem>
        );
    }
}

export default ModalAgregarInsumoRequisicion;
